@if (tariffConfig) {
    <form name="pricesForm" [formGroup]="pricesForm">
        @if (!canUserChooseUnit) {
            <div class="row">
                <!-- First PriceByUnit -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="priceByUnit">
                        {{ 'services.tariff.modal.priceByUnit' | translate }}*
                    </label>
                    <div class="input-group">
                        <span class="input-group-text">CHF</span>
                        <input class="form-control" id="priceByUnit" type="number" name="priceByUnit"
                               [formControl]="priceByUnit"
                               (keydown)="FormUtils.validateInputNumberLength($event, 10)" required>
                    </div>
                    <app-form-error [control]="priceByUnit"></app-form-error>
                </div>

                <!-- First Unit -->
                @if (tariffConfig.tariffConfigUnits.length > 0 && availableConfigUnits.length > 0) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="unit">
                            {{ 'services.tariff.modal.unit' | translate }}*
                        </label>
                        <select class="form-control form-select" id="unit" name="unit"
                                [formControl]="unit">
                            @for (tariffConfigUnit of availableConfigUnits; track tariffConfigUnit) {
                                <option [ngValue]="tariffConfigUnit">
                                    {{ 'common.units.' + tariffConfigUnit.unitEnumName + '.' + tariffConfigUnit.unitEnumValue | translate }}
                                </option>
                            }
                        </select>
                    </div>
                }
            </div>
        }

        <!-- Custom Units -->
        @if (tariffConfig.tariffConfigUnits.length === 0 || (availableConfigUnits.length === 0 && !canUserChooseUnit)) {
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="form-label" for="customUnitFR">
                        {{ 'services.tariff.modal.unit' | translate }}(FR)*
                    </label>
                    <input class="form-control" id="customUnitFR" name="customUnitFR" type="text"
                           [formControl]="customUnitFR"
                           pattern="{{ FormUtils.textInputPattern }}" maxlength="25">
                    <app-form-error [control]="customUnitFR"></app-form-error>
                </div>

                @if (customerConfigService.isLanguageAvailable('de')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="customUnitDE">{{ 'services.tariff.modal.unit' | translate }}
                            (DE)</label>
                        <input class="form-control" id="customUnitDE" name="customUnitDE" type="text"
                               [formControl]="customUnitDE"
                               pattern="{{ FormUtils.textInputPattern }}" maxlength="25">
                        <app-form-error [control]="customUnitDE"></app-form-error>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('it')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="customUnitIT">{{ 'services.tariff.modal.unit' | translate }}
                            (IT)</label>
                        <input class="form-control" id="customUnitIT" name="customUnitIT" type="text"
                               [formControl]="customUnitIT"
                               pattern="{{ FormUtils.textInputPattern }}" maxlength="25">
                        <app-form-error [control]="customUnitIT"></app-form-error>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('en')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="customUnitEN">{{ 'services.tariff.modal.unit' | translate }}
                            (EN)</label>
                        <input class="form-control" id="customUnitEN" name="customUnitEN" type="text"
                               [formControl]="customUnitEN"
                               pattern="{{ FormUtils.textInputPattern }}" maxlength="25">
                        <app-form-error [control]="customUnitEN"></app-form-error>
                    </div>
                }
            </div>
        }

        <!-- units fields -->
        @if (canUserChooseUnit) {
            @for (unit of units.controls; track unit; let i = $index) {
                <div class="row">
                    <!-- PriceByUnit -->
                    <div class="col-12 col-md-6">
                        @if (i === 0) {
                            <label class="form-label" for="priceByUnit-{{i}}">
                                {{ 'services.tariff.modal.priceByUnit' | translate }}*
                            </label>
                        }

                        <div class="input-group mb-3">
                            <span class="input-group-text">CHF</span>
                            <input class="form-control" id="priceByUnit-{{i}}" type="number" name="priceByUnit-{{i}}"
                                   formArrayName="prices"
                                   [formControl]="prices.controls[i]"
                                   [value]="prices.value[i]"
                                   (keydown)="FormUtils.validateInputNumberLength($event, 10)" required>
                        </div>
                    </div>

                    <!-- Unit -->
                    <div class="col-12 col-md-6">
                        @if (i === 0) {
                            <label
                                class="form-label d-none d-sm-block">{{ 'services.tariff.modal.units' | translate }}</label>
                        }

                        <input class="form-control" id="unit-{{i}}" type="text" name="unit-{{i}}"
                               [defaultValue]="'common.units.' + units.value[i].unitEnumName + '.' + units.value[i].unitEnumValue | translate"
                               disabled>
                    </div>
                </div>
            }

            <app-form-error [control]="prices"></app-form-error>
        }
        <!-- Second Unit Fields -->
        @if (tariffConfig.tariffType === TariffType.ConsumptionAndDuration ||
        tariffConfig.tariffType === TariffType.FlatAndConsumption ||
        tariffConfig.tariffType === TariffType.FlatAndDuration ||
        tariffConfig.tariffType === TariffType.FlatAndConsumptionAndDuration) {
            <div class="row">
                <!-- Second PriceByUnit -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="secondPriceByUnit">
                        {{ 'services.tariff.modal.priceByUnit' | translate }}*
                    </label>
                    <div class="input-group">
                        <span class="input-group-text">CHF</span>
                        <input class="form-control" id="secondPriceByUnit" type="number" name="secondPriceByUnit"
                               [formControl]="secondPriceByUnit"
                               (keydown)="FormUtils.validateInputNumberLength($event, 10)" required>
                    </div>

                    <app-form-error [control]="secondPriceByUnit"></app-form-error>
                </div>

                <!-- Second Unit -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="secondUnit">{{ 'services.tariff.modal.unit' | translate }}*</label>
                    <select class="form-control form-select" id="secondUnit" name="secondUnit"
                            [formControl]="secondUnit">
                        @for (tariffConfigUnit of availableSecondConfigUnits; track tariffConfigUnit) {
                            <option
                                [ngValue]="tariffConfigUnit">{{ 'common.units.' + tariffConfigUnit.unitEnumName + '.' + tariffConfigUnit.unitEnumValue | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }

        <!-- Third Unit Fields -->
        @if (tariffConfig.tariffType === TariffType.FlatAndConsumptionAndDuration) {
            <div class="row">
                <!-- Thid PriceByUnit -->
                <div class="col-12 col-md-6">
                    <label class="form-label"
                           for="thirdPriceByUnit">{{ 'services.tariff.modal.priceByUnit' | translate }}
                        *</label>
                    <div class="input-group">
                        <span class="input-group-text">CHF</span>
                        <input class="form-control" id="thirdPriceByUnit" type="number" name="thirdPriceByUnit"
                               [formControl]="thirdPriceByUnit"
                               (keydown)="FormUtils.validateInputNumberLength($event, 10)" required>
                    </div>

                    <app-form-error [control]="thirdPriceByUnit"></app-form-error>
                </div>

                <!-- Third Unit -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="thirdUnit">{{ 'services.tariff.modal.unit' | translate }}*</label>
                    <select class="form-control form-select" id="thirdUnit" name="thirdUnit"
                            [formControl]="thirdUnit">
                        @for (tariffConfigUnit of availableThirdConfigUnits; track tariffConfigUnit) {
                            <option
                                [ngValue]="tariffConfigUnit">{{ 'common.units.' + tariffConfigUnit.unitEnumName + '.' + tariffConfigUnit.unitEnumValue | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }
    </form>
}
